import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      class: "form",
      ref: "brandRule",
      rules: _ctx.standardForm,
      model: _ctx.formData,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "配规起止时间：",
          style: {"width":"100%"},
          required: "",
          prop: "rule_start_date"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              class: "input-item",
              "disabled-date": _ctx.disabledStartRuleDate,
              disabled: _ctx.t==2,
              onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeRuleDate(_ctx.formData.rule_start_date))),
              modelValue: _ctx.formData.rule_start_date,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.rule_start_date) = $event)),
              type: "date",
              "value-format": "YYYY-MM-DD",
              placeholder: "配规开始时间"
            }, null, 8, ["disabled-date", "disabled", "modelValue"]),
            _cache[29] || (_cache[29] = _createElementVNode("span", { class: "center" }, "-", -1)),
            _createVNode(_component_el_date_picker, {
              class: "input-item",
              "disabled-date": _ctx.disabledEndRuleDate,
              disabled: _ctx.t==2,
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeRuleDate(_ctx.formData.rule_end_date))),
              modelValue: _ctx.formData.rule_end_date,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.rule_end_date) = $event)),
              type: "date",
              placeholder: "配规结束时间",
              "value-format": "YYYY-MM-DD"
            }, null, 8, ["disabled-date", "disabled", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "品牌：",
          style: {"width":"400px"},
          prop: "brand_id",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select_v2, {
              modelValue: _ctx.formData.brand_id,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.brand_id) = $event)),
              disabled: _ctx.t==2,
              filterable: "",
              placeholder: "请选择品牌",
              onChange: _ctx.onBrandChange,
              options: _ctx.brandList,
              props: {
                        value: 'id',
                        label: 'name'
                    }
            }, null, 8, ["modelValue", "disabled", "onChange", "options"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "配送类型：",
          style: {"width":"400px"},
          required: "",
          prop: "ship_type"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _ctx.formData.ship_type,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.ship_type) = $event)),
              disabled: _ctx.t==2 || _ctx.shipType=='上门/自提' || _ctx.shipType=='快递'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, { label: 1 }, {
                  default: _withCtx(() => _cache[30] || (_cache[30] = [
                    _createTextVNode("快递")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: 2 }, {
                  default: _withCtx(() => _cache[31] || (_cache[31] = [
                    _createTextVNode("上门/自提")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        (_ctx.formData.ship_type==1)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "配送描述：",
              style: {"width":"800px"},
              required: "",
              prop: "distribution_range"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  placeholder: "例：1月1日-1月10日只接单不发货，1月11日陆续发货",
                  modelValue: _ctx.formData.distribution_range,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.distribution_range) = $event)),
                  disabled: _ctx.t==2,
                  "show-word-limit": "",
                  maxlength: "50",
                  clearable: ""
                }, null, 8, ["modelValue", "disabled"]),
                _cache[32] || (_cache[32] = _createElementVNode("div", {
                  class: "suffix",
                  style: {"margin-left":"10px","color":"#E6A23C"}
                }, "注：此描述将会展示给用户，请谨慎填写", -1))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.formData.ship_type==2)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: "城市："
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  disabled: _ctx.t==2,
                  modelValue: _ctx.formData.city_id,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.city_id) = $event)),
                  filterable: "",
                  clearable: "",
                  placeholder: "请选择城市"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cityList, (group) => {
                      return (_openBlock(), _createBlock(_component_el_option_group, {
                        key: group.lable,
                        label: group.lable
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.lable,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.userName === 'gnss' || _ctx.userName === 'ceshidangao')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 2,
              label: "运费：",
              style: {"width":"400px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "number",
                  placeholder: "请输入运费",
                  disabled: _ctx.t==2,
                  modelValue: _ctx.formData.ship_amount,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.ship_amount) = $event)),
                  modelModifiers: { trim: true },
                  max: "50",
                  onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.formData.ship_amount>50 || _ctx.formData.ship_amount<0 ?_ctx.formData.ship_amount='':null))
                }, {
                  append: _withCtx(() => _cache[33] || (_cache[33] = [
                    _createTextVNode("元")
                  ])),
                  _: 1
                }, 8, ["disabled", "modelValue"])
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_el_form_item, {
              key: 3,
              label: "运费：",
              style: {"width":"400px"},
              required: "",
              prop: "ship_amount"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "number",
                  placeholder: "请输入运费",
                  disabled: _ctx.t==2,
                  modelValue: _ctx.formData.ship_amount,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.ship_amount) = $event)),
                  modelModifiers: { trim: true },
                  max: "50",
                  onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.formData.ship_amount>50 || _ctx.formData.ship_amount<0 ?_ctx.formData.ship_amount='':null))
                }, {
                  append: _withCtx(() => _cache[34] || (_cache[34] = [
                    _createTextVNode("元")
                  ])),
                  _: 1
                }, 8, ["disabled", "modelValue"])
              ]),
              _: 1
            })),
        (_ctx.formData.brand_cat_id ==5 && _ctx.formData.ship_type==1 && _ctx.isSpecialDate())
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 4,
              label: "白名单申请原因：",
              style: {"width":"800px"},
              required: "",
              prop: "white_reson"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  placeholder: "请输入白名单申请原因",
                  disabled: _ctx.t==2,
                  modelValue: _ctx.formData.white_reson,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.white_reson) = $event)),
                  "show-word-limit": "",
                  maxlength: "50",
                  clearable: ""
                }, null, 8, ["disabled", "modelValue"]),
                _cache[35] || (_cache[35] = _createElementVNode("div", {
                  class: "suffix",
                  style: {"margin-left":"10px","color":"#E6A23C"}
                }, "注：白名单申请时间为国庆（10.1）前15天和国庆（10.1）后7天，春节（正月初一）前30天和春节（正月初一）后10天", -1))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.formData.ship_type==2)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 5,
              label: "是否营业：",
              required: "",
              style: {"width":"400px"},
              prop: "yingye_status"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.formData.yingye_status,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.yingye_status) = $event)),
                  onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleChangeTrade(_ctx.formData.yingye_status))),
                  disabled: _ctx.t==2
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => _cache[36] || (_cache[36] = [
                        _createTextVNode("是")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 2 }, {
                      default: _withCtx(() => _cache[37] || (_cache[37] = [
                        _createTextVNode("否")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.formData.ship_type==2 && _ctx.formData.yingye_status==2)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 6,
              label: "闭店起止时间：",
              disabled: "",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      class: "input-item",
                      "disabled-date": _ctx.disabledStartStopDate,
                      disabled: _ctx.t==2,
                      modelValue: _ctx.formData.stop_start_date,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.stop_start_date) = $event)),
                      type: "date",
                      "value-format": "YYYY-MM-DD",
                      placeholder: "闭店开始时间"
                    }, null, 8, ["disabled-date", "disabled", "modelValue"]),
                    _cache[38] || (_cache[38] = _createElementVNode("span", { class: "center" }, "-", -1)),
                    _createVNode(_component_el_date_picker, {
                      class: "input-item",
                      "disabled-date": _ctx.disabledEndStopDate,
                      disabled: _ctx.t==2,
                      modelValue: _ctx.formData.stop_end_date,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.stop_end_date) = $event)),
                      type: "date",
                      placeholder: "闭店结束时间",
                      "value-format": "YYYY-MM-DD"
                    }, null, 8, ["disabled-date", "disabled", "modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.formData.ship_type==2 && _ctx.formData.yingye_status==1)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 7,
              label: "是否支持上门配送：",
              required: "",
              style: {"width":"400px"},
              prop: "can_ship"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  disabled: _ctx.t==2,
                  modelValue: _ctx.formData.can_ship,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.can_ship) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => _cache[39] || (_cache[39] = [
                        _createTextVNode("是")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 2 }, {
                      default: _withCtx(() => _cache[40] || (_cache[40] = [
                        _createTextVNode("否")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.formData.ship_type==2 && _ctx.formData.yingye_status==1)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 8,
              label: "配送起止时间：",
              required: "",
              style: {"width":"100%"},
              prop: "ship_start_date"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      class: "input-item",
                      "disabled-date": _ctx.disabledStartDate,
                      disabled: _ctx.t==2,
                      modelValue: _ctx.formData.ship_start_date,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.ship_start_date) = $event)),
                      type: "date",
                      "value-format": "YYYY-MM-DD",
                      placeholder: "配送开始时间"
                    }, null, 8, ["disabled-date", "disabled", "modelValue"]),
                    _cache[41] || (_cache[41] = _createElementVNode("span", { class: "center" }, "-", -1)),
                    _createVNode(_component_el_date_picker, {
                      class: "input-item",
                      "disabled-date": _ctx.disabledEndDate,
                      disabled: _ctx.t==2,
                      modelValue: _ctx.formData.ship_end_date,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.ship_end_date) = $event)),
                      type: "date",
                      placeholder: "配送结束时间",
                      "value-format": "YYYY-MM-DD"
                    }, null, 8, ["disabled-date", "disabled", "modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.formData.ship_type==2 && _ctx.formData.yingye_status==1 && _ctx.formData.can_ship==1)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 9,
              label: "配送时间段：",
              required: "",
              style: {"width":"400px"},
              prop: "ship_times"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  disabled: _ctx.t==2,
                  modelValue: _ctx.formData.ship_times,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.ship_times) = $event)),
                  modelModifiers: { trim: true },
                  type: "textarea",
                  row: 4,
                  onBlur: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onInput(_ctx.formData.ship_times))),
                  placeholder: "例：9:00-12:00,11:00-13:00...",
                  clearable: ""
                }, null, 8, ["disabled", "modelValue"]),
                _cache[42] || (_cache[42] = _createElementVNode("span", {
                  class: "suffix",
                  style: {"margin-left":"10px","color":"#E6A23C"}
                }, "注：配送时间段，多个以英文逗号分隔", -1))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.formData.ship_type==2 && _ctx.formData.yingye_status==1)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 10,
              label: "是否支持门店自提：",
              required: "",
              style: {"width":"400px"},
              prop: "can_take"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  disabled: _ctx.t==2,
                  modelValue: _ctx.formData.can_take,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.can_take) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => _cache[43] || (_cache[43] = [
                        _createTextVNode("是")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 2 }, {
                      default: _withCtx(() => _cache[44] || (_cache[44] = [
                        _createTextVNode("否")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.formData.ship_type==2 && _ctx.formData.yingye_status==1)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 11,
              label: "自提起止时间：",
              required: "",
              disabled: "",
              style: {"width":"100%"},
              prop: "take_start_date"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      disabled: _ctx.t==2,
                      "disabled-date": _ctx.disabledStartDate,
                      class: "input-item",
                      modelValue: _ctx.formData.take_start_date,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.take_start_date) = $event)),
                      type: "date",
                      "value-format": "YYYY-MM-DD",
                      placeholder: "自提开始时间"
                    }, null, 8, ["disabled", "disabled-date", "modelValue"]),
                    _cache[45] || (_cache[45] = _createElementVNode("span", { class: "center" }, "-", -1)),
                    _createVNode(_component_el_date_picker, {
                      "disabled-date": _ctx.disabledEndDate,
                      disabled: _ctx.t==2,
                      class: "input-item",
                      modelValue: _ctx.formData.take_end_date,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.take_end_date) = $event)),
                      type: "date",
                      placeholder: "自提结束时间",
                      "value-format": "YYYY-MM-DD"
                    }, null, 8, ["disabled-date", "disabled", "modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.formData.ship_type==2 && _ctx.formData.yingye_status==1 && _ctx.formData.can_take ==1)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 12,
              label: "自提时间段：",
              required: "",
              style: {"width":"400px"},
              prop: "take_times"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  disabled: _ctx.t==2,
                  onBlur: _cache[25] || (_cache[25] = ($event: any) => (_ctx.onInput(_ctx.formData.take_times))),
                  modelValue: _ctx.formData.take_times,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.take_times) = $event)),
                  modelModifiers: { trim: true },
                  type: "textarea",
                  row: 4,
                  placeholder: "例：9:00-12:00,11:00-13:00...",
                  clearable: ""
                }, null, 8, ["disabled", "modelValue"]),
                _cache[46] || (_cache[46] = _createElementVNode("span", {
                  class: "suffix",
                  style: {"margin-left":"10px","color":"#E6A23C"}
                }, "注：自提时间段，多个以英文逗号分隔", -1))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "info",
              plain: "",
              onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.router.go(-1)))
            }, {
              default: _withCtx(() => _cache[47] || (_cache[47] = [
                _createTextVNode("返回")
              ])),
              _: 1
            }),
            (_ctx.t!=2)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.submitForm()))
                }, {
                  default: _withCtx(() => _cache[48] || (_cache[48] = [
                    _createTextVNode("保存")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _cache[49] || (_cache[49] = _createElementVNode("span", {
              class: "suffix",
              style: {"margin-left":"10px","color":"#E6A23C"}
            }, [
              _createTextVNode("注：该模块仅限于整个品牌；若部分商品使用此配规，需选择批量添加"),
              _createElementVNode("br"),
              _createElementVNode("p", { style: {"margin-left":"164px","color":"red"} }, "修改提交后只对平台配送规则展示生效。品牌延迟发货申请只在春节和国庆期间生效")
            ], -1))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["rules", "model"])
  ]))
}